export default {
  // 切换登录状态
  changeLoginStatus (state, bool) {
    state.isLogin = bool
  },
  // 切换侧边栏状态
  changeSidebarStatus (state, bool) {
    state.sidebarSwitch = bool
  },
  setApiPermission (state, arr) {
    state.apiPermission = arr
  },
  // 将页面加入keep-alive
  keepIn (state, keepComponent) {
    state.includes.push(keepComponent)
  },
  // 将页面从keep-alive中除去
  keepOut (state) {
    state.includes = []
  },
  // 设置菜单高亮
  setMenuActive (state, str) {
    state.menuActive = str
  },
  // 设置面包屑导航的值
  setBreadList (state, arr) {
    state.breadList = arr
  },
  // 设置全局path
  setFullPath (state, str) {
    state.fullPath = str
  }
}
